import type { LogLayerPlugin } from "loglayer";

import { log } from "@core/services/logging/logger";

import { getCurrentProject } from "@archipad/backend/project/baseProjectContext";
import syncSessionService from "@archipad/logs/sync-session.service";
import offlineService from "@archipad/services/offline.service";

/**
 * Adds the global Archipad context to every log: current opened project (see `currentProject$`), its sync session and the network status.
 */
const archipadContextPlugin: LogLayerPlugin = {
    id: "archipad-context",
    onBeforeDataOut: ({ data }) => {
        const projectId: string | null = data?.["archipad.project.id"] ?? getCurrentProject()?.id ?? null;
        return {
            ...(projectId && {
                "archipad.project.id": projectId,
                "archipad.sync.session_id": syncSessionService.getSessionId(projectId),
            }),
            "archipad.network.online": offlineService.isOnline(),
            ...data,
        };
    },
};

/**
 * Browser page only (it reads `navigator`): the Node tools and the service worker log without this context.
 * To call once at startup.
 */
export function registerArchipadContextPlugin(): void {
    log.addPlugins([archipadContextPlugin]);
}
